<template lang="pug">
v-card.mb-6(
  color="secondary"
  dark
  flat
  v-if="conferences.length"
).sdo-radius
  v-list-item
    v-list-item-content
      .text-body-1.white--text Ближайшие трансляции
    v-list-item-action
      .d-flex.flex-nowrap
        v-btn.ml-auto(
          icon
          :disabled="conferenceIdx === 0"
          @click="conferenceIdx -= 1"
        ): v-icon mdi-chevron-left
        v-btn(
          icon
          :disabled="conferenceIdx === conferences.length - 1"
          @click="conferenceIdx += 1"
        ): v-icon mdi-chevron-right

  v-slide-x-transition(hide-on-leave)
    v-list(color="transparent" :key="selectedConference.id").pb-0
      v-list-item
        v-list-item-content.my-0
          .text-body-1: strong {{selectedConference.courseTitle}}

      v-list-item
        v-list-item-content
          p {{ conferencePrefix(selectedConference.date_start) }}
            strong.ml-2 {{ selectedConference.date_start | dateprint_from_now}}

  v-card-actions.pt-0
    v-btn(
      rounded large
      block text
      :href="selectedConference.link"
    )
      span Перейти к трансляции
      v-icon(right style="padding-top: 4px" ).mr-2 mdi-arrow-right
</template>
<script>
import { format, isAfter } from 'date-fns';

export default {
  data() {
    return {
      conferences: [],
      conferenceIdx: 0,
      selectedConference: {},
    };
  },
  watch: {
    conferenceIdx(val) {
      this.selectedConference = this.conferences[val];
    },
  },
  created() {
    this.fetchTranslations();
  },
  methods: {
    conferencePrefix(startDate) {
      return !isAfter(new Date(), new Date(`${startDate}Z`)) ? 'Начало' : ' Началось';
    },
    async fetchTranslations() {
      const query = {
        sort: 'date_start',
        'search[from_date]': format(new Date(), 'yyyy-MM-dd'),
      };
      query['search[im_learning]'] = true;
      const { items } = await this.$api.telegram.conferenceIndex(query);
      const jazz = await this.$api.schedule.index({ ...query, expand: 'lesson,meeting' });

      this.conferences = [
        ...jazz.data.data.map((i) => ({
          id: i.id,
          type: this.$conf.CONFERENCE_SOURCE.jazz,
          description: i.lesson.description,
          isForbidden: i.isForbidden,
          courseTitle: i.lesson.name,
          date_start: i.date_start,
          date_end: i.date_end,
          link: this.meeting.url,
        })),
        ...items.map((i) => ({
          id: i.id,
          type: this.$conf.CONFERENCE_SOURCE.telegram,
          conference: i.conference,
          courseTitle: i.title,
          date_start: i.date_start,
          date_end: i.date_end,
          link: i.conference.group.invite_link,

        })),
      ].filter(({ date_end: dateEnd }) => {
        const result = isAfter(new Date(), new Date(`${dateEnd}Z`));
        return !result;
      });
      [this.selectedConference] = this.conferences;
    },
  },
};
</script>
